import React from 'react'
import { Link } from './Link'

const Navigation = ({ closeMenu }) => (
  <nav>
    <Link to="/about" className="nav-link" onClick={closeMenu}>
      <span>About</span>
    </Link>
    <Link to="/what-i-provide" className="nav-link" onClick={closeMenu}>
      <span>What I Provide</span>
    </Link>
    <a
      className="nav-link"
      href="https://www.therapyportal.com/p/neophdllc/"
      target="_blank"
      rel="noopener noreferrer"
    >
      Patient Portal
    </a>
    {/* <Link to="/forms" className="nav-link" onClick={closeMenu}>
      <span>Forms</span>
    </Link> */}
  </nav>
)

export { Navigation }
